import { render, staticRenderFns } from "./OrgChart.vue?vue&type=template&id=2de1d445"
import script from "./OrgChart.vue?vue&type=script&lang=js"
export * from "./OrgChart.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

/* hot reload */
if (module.hot) {
  var api = require("/home/tomi/Projects/ingeniAR/rrhh/Frontend/node_modules/vue-hot-reload-api/dist/index.js")
  api.install(require('vue'))
  if (api.compatible) {
    module.hot.accept()
    if (!api.isRecorded('2de1d445')) {
      api.createRecord('2de1d445', component.options)
    } else {
      api.reload('2de1d445', component.options)
    }
    module.hot.accept("./OrgChart.vue?vue&type=template&id=2de1d445", function () {
      api.rerender('2de1d445', {
        render: render,
        staticRenderFns: staticRenderFns
      })
    })
  }
}
component.options.__file = "src/views/OrgChart/OrgChart.vue"
export default component.exports